import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import { actions as authActions } from '../../../actions/authActions';
import RegistrationForm from './RegistrationForm';
import AnonymousContentPanel from '../AnonymousContentPanel';

class RegistrationPage extends React.Component {
  constructor() {
    super();
    this.state = {
      activated: false
    };
  }

  register = data => {
    return this.props.authActions.register(data)
      .then(result => {
        if (result.ok) {
          this.setState({ activated: true });
        } else {
          return result;
        }
      });
  }

  render() {
    const { submitting } = this.props;

    return (
      <AnonymousContentPanel>
        {this.state.activated
        ? <p>Na wskazany adres email został wysłany link aktywacyjny, który umożliwi potwierdzenie konta.</p>
        : <RegistrationForm
            onSubmit={data => this.register(data)}
            submitting={submitting}
          />}
      </AnonymousContentPanel>);
  }
}

RegistrationPage.propTypes = {
  authActions: PropTypes.object.isRequired,
  submitting: PropTypes.bool,
  returnTo: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  };
}

function mapStateToProps(state, ownProps) {
  const parsed = queryString.parse(ownProps.location.search);
  return {
    submitting: state.auth.submitting,
    returnTo: parsed.returnTo,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPage);



// WEBPACK FOOTER //
// ./src/components/auth/registration/RegistrationPage.js